import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';

class EditSubject extends Component {
	
	constructor(props){
		super(props);
		this.state = {
			_message : '',
			alertClass :'',
			id : '',
			res : '',
			cls : '',
			scode : '',
			subj : '',
			posts : []
		}
		this.handleInputChange = this.handleInputChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.getdetails = this.getdetails.bind(this);
		this.back = this.back.bind(this);
	}
	
	/** redirect to Subject **/
	back(e){
		
		this.setState({_redirect :true});
	}
	
	handleInputChange(e){
		
		this.setState({[e.target.name]:e.target.value});
		// console.log(this.state);
	}
	
	onSubmit(e){
		e.preventDefault();
		if(this.state.scode && this.state.subj){
			$("#showLoader").show();
			console.log(this.state);
			PostData('subject/updatesub',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Subject Updated Successfullly',
						alertClass:'alert alert-success'
					});	
					this.getdetails();
				}
				else{
				this.getdetails();
					this.setState({
						_message:'Already Added',
						alertClass:'alert alert-danger'
					});
				}
			});
		
		}
	
	}
	
	componentWillMount(){
		
		this.getdetails();
	}
	
	getdetails(){
	  $("#showLoader").show();
		GetData('subject/getsubbyid/'+this.props.match.params.id).then((result) => {
			$("#showLoader").hide();
			let res = result;
			if(res){
				this.setState({
					cls : res[0]['class'],
					scode : res[0]['subcode'],
					subj: res[0]['subject']
				});
			}
		});
	}
	
	
  render() {
	  
	this.state.id = this.props.match.params.id;
	
	if(this.state._redirect){
		  
		return (<Redirect to='/academic/subject/subject' />);
	}
	
    return (
		<div className="animated fadeIn">
			<div className={this.state.alertClass}>
				{this.state._message}
			</div>
			<Row>
			  <Col md="12">
				<Card>
				  <form action="" method="post" id="subform" encType="multipart/form-data" onSubmit={this.onSubmit} >
					<CardHeader>
						<strong>Edit Subject</strong>
						<span className="pull-right">
							<Button outline color="primary" onClick={this.back}>Back</Button>
						</span>
					</CardHeader>
					<CardBody>
						<Row>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Subject Code <span className="text-danger">*</span></Label>
							  <Input type="text" name="scode" required onChange={this.handleInputChange} value={this.state.scode}/>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Subject Name <span className="text-danger">*</span></Label>
							  <Input type="text" name="subj" onChange={this.handleInputChange} required value={this.state.subj} />
							</FormGroup>
						  </Col>
						</Row>
					</CardBody>
					<CardFooter>
						<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Update</Button>
					</CardFooter>
				  </form>
				</Card>
			  </Col>
			</Row>
		</div>
	);
  }
}

export default EditSubject;



// WEBPACK FOOTER //
// ./src/subject/Subject/EditSubject.js